import { render, staticRenderFns } from "./viewMedias.vue?vue&type=template&id=3e96fa74"
import script from "./viewMedias.vue?vue&type=script&lang=js"
export * from "./viewMedias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports